import { Dispatch } from 'react';
import { UploadFile } from 'antd';
import { useIntl } from 'react-intl';
import { StyledCreateEditProductsGallery } from './style';
import { FileUploader } from '../FileUploader';

interface CreateEditProductsGalleryProps {
  onFileListChange?: Dispatch<any>;
  fileList: UploadFile[];
  selectedImageName?: string;
  setSelectedImageName?: React.Dispatch<
    React.SetStateAction<string | undefined>
  >;
}

export const CreateEditProductsGallery = ({
  onFileListChange,
  fileList,
  selectedImageName,
  setSelectedImageName,
}: CreateEditProductsGalleryProps) => {
  const intl = useIntl();
  return (
    <StyledCreateEditProductsGallery>
      <FileUploader
        fileList={fileList}
        onFileListChange={onFileListChange}
        showActions={true}
        multiple={true}
        title={intl.formatMessage({ id: 'general.gallery_title' })}
        isCrop={false}
        aspectRatio={1}
        selectedImageName={selectedImageName}
        setSelectedImageName={setSelectedImageName}
        horizontal={false}
        selectable={true}
      />
    </StyledCreateEditProductsGallery>
  );
};
